import { Button } from "@redelair-sa/intiza-ui";
import { TranslationService } from "../../../services/TranslationService";

interface AgendaEmptyStateProps {
  canGenerate: boolean;
  onGenerate: () => void;
}

/** Shown when today's agenda was not generated yet (generated = false). */
const AgendaEmptyState = ({
  canGenerate,
  onGenerate
}: AgendaEmptyStateProps) => {
  const { translate } = TranslationService;
  return (
    <div className="agenda-card agenda-empty">
      <i
        className="fa-regular fa-calendar-check agenda-empty__icon"
        aria-hidden="true"
      />
      <h2 className="agenda-empty__title">{translate.AgendaEmptyTitle}</h2>
      <p className="agenda-empty__text">{translate.AgendaEmptyText}</p>
      {canGenerate && (
        <Button variant="primary" onClick={onGenerate}>
          {translate.AgendaGenerateToday}
        </Button>
      )}
    </div>
  );
};

export default AgendaEmptyState;
